import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { fetchConfig } from '../../api/config'
import { ConfigLoading } from './widgets'

export const ConfigProvider = ({ children }) => {
  const config = useSelector(state => state?.config?.config)
  const isLoaded = !!(config?.publicBackendUrl && config?.apiUri)

  useEffect(() => {
    fetchConfig()
  }, [])

  if (!isLoaded) {
    return <ConfigLoading />
  }

  return children
}
